module.exports.loanCalculator = function () {
    var moneydown = true;
    var timeoutId = '';
    var secs = 500;

    var truepercent = 0;
    var trueValue = 0;

    var plot1 = "";
    var plot2 = "";

    var plotS1 = [];

    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1 && ua.indexOf("mobile") > -1 && ua.indexOf("linux") > -1;
    var is_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;


    $.fn.fcbtLoanCalc = function (options) {

        /*set default value -- change with options parameter 
        options gathered from CMS 
        */
        var settings = $.extend({
            purchasePrice: 200000,
            downPayment: 20000,
            loanTerms: [15, 30],
            loanTermDefault: 15,
            interestRate: [3.5, 4.25, 6.5],
            propertyTaxes: 1.2,
            homeInsurance: 400,
            hoaDues: 30,
            hoaDuesOn: true,
            hasPaymentFrequency: false,
            noInterestSelect: false,
            noLoanTermSelect: false
        }, options);

        /*end of set up controls */
        var html = '';


        html += '<div id="divMortgage">';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';

        html += '<ul class="nav nav-tabs" id="myTab">';
        html += '<li><a href="#principal" class="small noarrow active">Loan</a></li>';
        html += '<li><a href="#charts" class="small noarrow">Charts</a></li>';
        html += '<li><a href="#amort" class="small noarrow" id="liMort">Amortization</a></li>';
        html += '</ul>';

        html += '</div>';
        html += '<div class="col-sm-24 nopadlr">';
        html += '<div class="tab-content nopadlr">';

        html += '<div class="tab-pane active" id="principal"><div class="row">';
        html += '<div class="col-sm-12">';
        html += '<div class="row mt-10">';
        html += '<div class="col-sm-24">';
        html += '<label for="txtPurchasePrice">Purchase price<span class="reqcal">*</span></label>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row mb-15 mb-md-5">';
        html += '<div class="col-sm-24">';
        html += '<div class="input-group">';
        html += '<div class="input-group-prepend"><span class="input-group-text">$</span></div>';
        html += '<input type="tel" class="form-control" id="txtPurchasePrice" maxlength="10" data-btnclear="true" />';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<label for="txtDownPayment">Down payment<span class="reqcal">*</span><span id="downhint" class="tiny">(click % for percent)</span></label>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row mb-15 mb-md-5">';
        html += '<div class="col-sm-24">';
        html += '<div class="input-group form-inline">';
        html += '<div class="input-group-prepend"><span class="input-group-text" id="btnMoneyDown">$</span></div>';
        html += '<div class="input-group-prepend"><span class="input-group-text" id="btnPercentDown">%</span></div>';
        html += '<input type="tel" class="form-control" id="txtDown" maxlength="10" data-btnclear="true" />';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<label for="dropLoanTerms">Loan term<span class="reqcal">*</span></label>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row mb-15 mb-md-5">';
        html += '<div class="col-sm-24">';
        html += '<div class="input-group form-inline">';
        html += '<select class="form-control" id="dropLoanTerms">';
        html += '</select>';
        html += '<input type="tel" class="form-control" id="txtLoanTerms" maxlength="2" data-btnclear="true"  />';
        html += '<div class="input-group-append"><span class="input-group-text">yr</span></div>';
        html += '</div>';
        html += '</div>';
        html += '</div>';

        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<label for="dropInterestRate">Interest rate<span class="reqcal">*</span></label>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<div class="input-group">';

        // if (is_firefox) {
        html += '<input type="text" class="form-control" id="txtInterestRate" maxlength="5" data-btnclear="true"/>';
        // }
        // else {
        //     html += '<input type="number" step="0.01" class="form-control" id="txtInterestRate" maxlength="5" data-btnclear="true"/>';
        //  }

        //html += '<input type="number" class="form-control" id="txtInterestRate" maxlength="5" data-btnclear="true" />';
        html += '<select class="form-control" id="dropInterestRate">';
        html += '</select>';

        html += '<div class="input-group-append"><span class="input-group-text">%</span></div>';
        html += '</div>';
        html += '<p class="tiny reqcal"><strong>* required</strong></p>';
        html += '</div>';
        html += '</div>';

        html += '</div>';
        html += '<div class="col-sm-12">';
        if (settings.hasPaymentFrequency == true) {
            html += '<div class="row mt-10">';
            html += '<div class="col-sm-24">';
            html += '<label for="dropPaymentFrequency">Payment Frequency<span class="reqcal">*</span></label>';
            html += '</div>';
            html += '</div>';
            html += '<div class="row mb-15 mb-md-5">';
            html += '<div class="col-sm-24"><div class="input-group">';
            html += '<select class="form-control" id="dropPaymentFrequency">';
            html += '<option value="12">Monthly</option>';
            html += '<option value="4">Quarterly</option>';
            html += '<option value="2">Semiannual</option>';
            html += '</select>';
            html += '</div></div>';
            html += '</div>';
        }
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<label for="txtPropertyTaxes">Property taxes</label>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row mb-15 mb-md-5">';
        html += '<div class="col-sm-24">';
        html += '<div class="input-group">';

        //html += '<input type="number" class="form-control" id="txtPropertyTaxes" maxlength="4" data-btnclear="true" />';

        //  if (is_firefox) {
        html += '<input type="text" class="form-control" id="txtPropertyTaxes" maxlength="4" data-btnclear="true"/>';
        //   } else {
        //      html += '<input type="number" step="0.01" class="form-control" id="txtPropertyTaxes" maxlength="4" data-btnclear="true"/>';
        //    }

        html += '<div class="input-group-append"><span class="input-group-text">%</span></div>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<label for="txtHomeInsurance">Home insurance</label>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row mb-15 mb-md-5">';
        html += '<div class="col-sm-24">';
        html += '<div class="input-group form-inline">';
        html += '<div class="input-group-prepend"><span class="input-group-text">$</span></div>';
        html += '<input type="tel" class="form-control" id="txtHomeInsurance" maxlength="6" data-btnclear="true" />';
        html += '<div class="input-group-append"><span class="input-group-text">/yr</span></div>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
        if (settings.hoaDuesOn == true) {
            html += '<div class="row">';
            html += '<div class="col-sm-24">';
            html += '<label for="txtHOADues">HOA dues</label>';
            html += '</div>';
            html += '</div>';
            html += '<div class="row mb-20">';
            html += '<div class="col-sm-24">';
            html += '<div class="input-group form-inline">';
            html += '<div class="input-group-addon">$</div>';
            html += '<input type="tel" class="form-control" id="txtHOADues" maxlength="4" data-btnclear="true" />';
            html += '<div class="input-group-addon">/mo</div>';
            html += '</div>';
            html += '</div>';
            html += '</div>';
        }
        html += '<div class="row">';
        html += '<div class="col-sm-24 mt-20">';
        html += '<div id="divmontlypayment"></div>';
        html += '</div>';
        html += '</div>';

        html += '</div>';
        html += '</div></div>';
        html += '<div class="tab-pane" id="charts">';
        html += '<div class="row mt-20">';
        html += '<div class="col-sm-24">';
        html += '<div id="nochart"></div>';
        html += '</div>';


        html += '<div class="col-sm-12">';
        html += '<div id="chart1" class="mb-60"></div>';
        html += '</div>';
        html += '<div class="col-sm-12">';
        html += '<div id="chart2" class="mb-60"></div>';
        html += '</div>';


        html += '</div>';
        html += '</div>';
        html += '<div class="tab-pane" id="amort">';
        html += '<div id="divAmortization" class="mt-20">';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<div id="mortamount"></div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row">';
        html += '<div class="col-sm-24">';
        html += '<div id="divamortholder"></div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="row">';
        html += '<div class="col-sm-24 mb-15 mb-md-5">';
        html += '<div id="divmontlypayment2"></div>';
        html += '</div>';
        html += '</div>';

        html += '</div>';



        html += '</div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="col-sm-24"><div class="row">';
        html += '<div class="col-sm-22">';
        html += '<p><small>';
        html += '<strong>Notice</strong> - This is not a credit decision or a commitment to lend. Estimated payment does not include taxes and insurance, which could result in a higher payment.';
        html += '</small></p>';
        html += '</div>';
        html += '</div>';
        html += '</div></div>';
        html += '</div>';




        this.html(html);
        //get input boxes add hidden add-on

        $('#btnMoneyDown').css({ backgroundColor: '#428BCA', color: 'white' });
        $(document).on("click", "#btnMoneyDown", function () {

            if (moneydown == false) {
                $(this).css({ backgroundColor: '#428BCA', color: 'white' });
                $('#btnPercentDown').css({ backgroundColor: '#EEEEEE', color: 'black' });
                $('#txtDown').val(switchValues($('#txtPurchasePrice').fcbtNumberOnly({ returnvalue: true }), $('#txtDown').fcbtPercentOnly({ returnvalue: true }), '$'));
                $("#txtDown").prop('maxLength', 10);
                if (isAndroid) {
                    setAndroidCurrencyFormat($('#txtDown'));
                } else {
                    $('#txtDown').fcbtCurrencyFormat();
                }
                $('#downhint').text(" (click % for percent)");
                $(document).off("keyup", "#txtDown");
                $(document).on("keyup", "#txtDown", function (e) {
                    if (goodkey(e.which) == true) {
                        $(this).fcbtCurrencyFormat();
                        callFcbtMortgagePayment();
                        addClearButton(this);
                    }
                });

                moneydown = true;
            }
        });
        $(document).on("click", "#btnPercentDown", function () {
            if (moneydown == true) {
                $(this).css({ backgroundColor: '#428BCA', color: 'white' });
                $('#btnMoneyDown').css({ backgroundColor: '#EEEEEE', color: 'black' });
                $('#txtDown').val(switchValues($('#txtPurchasePrice').fcbtNumberOnly({ returnvalue: true }), $('#txtDown').fcbtNumberOnly({ returnvalue: true }), '%'));
                $("#txtDown").prop('maxLength', 5);
                $('#downhint').text(" (click $ for dollar)");
                $(document).off("keyup", "#txtDown");
                $(document).on("keyup", "#txtDown", function (e) {
                    //calculate start value
                    if (goodkey(e.which) == true) {
                        $(this).fcbtPercentOnly({ numberOfDecimals: 2 });
                        callFcbtMortgagePayment();
                        addClearButton(this);
                    }
                });
                if ($('#txtDown').val() > 100) {
                    $('#txtDown').val(100);
                }

                moneydown = false;
            }
        });

        $('#btnMoneyDown').hover(function () {
            if (moneydown == false)
                $(this).css({ backgroundColor: '#428BCA', color: 'white' });

        },
            function () {
                if (moneydown == false)
                    $(this).css({ backgroundColor: '#EEEEEE', color: 'black' });
            });


        $('#btnPercentDown').hover(function () {
            if (moneydown == true)
                $(this).css({ backgroundColor: '#428BCA', color: 'white' });
        },
            function () {
                if (moneydown == true)
                    $(this).css({ backgroundColor: '#EEEEEE', color: 'black' });
            });

        $(document).on("keyup", "#txtPurchasePrice", function (e) {
            if (goodkey(e.which) == true) {
                $(this).fcbtCurrencyFormat();
                callFcbtMortgagePayment();
                addClearButton(this);
            }
        });
        $(document).on("keyup", "#txtDown", function (e) {
            if (goodkey(e.which) == true) {
                $(this).fcbtCurrencyFormat();
                callFcbtMortgagePayment();
                addClearButton(this);
            }
        });
        $(document).on("keyup", '#txtPropertyTaxes', function (e) {
            if (goodkey(e.which) == true) {
                $(this).fcbtPercentOnly({ numberOfDecimals: 2 });
                callFcbtMortgagePayment();
                addClearButton(this);
            }
        });
        $(document).on("keyup", '#txtInterestRate', function (e) {
            if (goodkey(e.which) == true) {
                $(this).fcbtPercentOnly({ numberOfDecimals: 2 });
                callFcbtMortgagePayment();
                addClearButton(this);
            }
        });
        $(document).on("keyup", '#txtLoanTerms', function (e) {
            if (goodkey(e.which) == true) {
                $(this).fcbtNumberOnly();
                callFcbtMortgagePayment();
                addClearButton(this);
            }
        });
        $(document).on("keyup", "#txtHomeInsurance", function (e) {
            if (goodkey(e.which) == true) {
                $(this).fcbtCurrencyFormat();
                callFcbtMortgagePayment()
                addClearButton(this);
            }
        });
        if (settings.hoaDuesOn == true) {
            $(document).on("keyup", "#txtHOADues", function (e) {
                if (goodkey(e.which) == true) {
                    $(this).fcbtCurrencyFormat();
                    callFcbtMortgagePayment();
                    addClearButton(this);
                }
            });
        }
        $(document).on("change", "#dropInterestRate", function () {
            $('#txtInterestRate').val($('#dropInterestRate').val());
            callFcbtMortgagePayment();
        });
        $(document).on("change", "#dropLoanTerms", function () {
            $('#txtLoanTerms').val($('#dropLoanTerms').val());
            callFcbtMortgagePayment();
        });
        $(document).on("change", "#dropPaymentFrequency", function () {
            callFcbtMortgagePayment();
        });

        // buildAmortTable();
        /*$(document).on('click', '#btnCalculate', function () {

            return false;
        });
       $(document).on('change', "#optMortgage", function () {

            if ($(this)[0].checked == true) {
                hideOptions();
                $('#divMortgage').show();
            }
        });
       $(document).on('change', "#optAmortization", function () {

            if ($(this)[0].checked == true) {
                hideOptions();
                buildAmortTable();
                $('#divAmortization').show();
            }
        });*/

        $(document).on('mousedown', '#liMort', function () {
            buildAmortTable();
        });


        if (isAndroid == true) {

            $(document).on("blur", '#txtPurchasePrice', function () {
                setAndroidCurrencyFormat(this);
            });
            $(document).on("blur", '#txtPropertyTaxes', function () {
                $(this).val($(this).fcbtPercentOnly({ returnvalue: true }));

            });
            $(document).on("blur", '#txtDown', function () {
                //check if value in text field is greater than 3 digits 
                if (moneydown == true) {
                    setAndroidCurrencyFormat(this);
                } else {
                    $(this).val($(this).fcbtPercentOnly({ returnvalue: true }));
                }
            });
            $(document).on("blur", '#txtLoanTerms', function () {
                setAndroidCurrencyFormat(this);
            });
            $(document).on("blur", '#txtHomeInsurance', function () {
                setAndroidCurrencyFormat(this);
            });

            if (settings.hoaDuesOn == true) {
                $(document).on("blur", '#txtHOADues', function () {
                    setAndroidCurrencyFormat(this);
                });
            }

            $(document).on("focus", '#txtPurchasePrice', function () {
                $(this).fcbtNumberOnly();
            });
            $(document).on("focus", '#txtPropertyTaxes', function () {
                $(this).fcbtPercentOnly();
            });
            $(document).on("focus", '#txtDown', function () {
                //check if value in text field is greater than 3 digits 
                if (moneydown == true) {
                    $(this).fcbtNumberOnly();
                } else {
                    $(this).fcbtPercentOnly();
                }
            });
            $(document).on("focus", '#txtLoanTerms', function () {
                $(this).fcbtNumberOnly();
            });
            $(document).on("focus", '#txtHomeInsurance', function () {
                $(this).fcbtNumberOnly();
            });
            if (settings.hoaDuesOn == true) {
                $(document).on("focus", '#txtHOADues', function () {
                    $(this).fcbtNumberOnly();
                });
            }
        }



        /*Set up controls */
        $('#txtPurchasePrice').val(settings.purchasePrice);
        $('#txtDown').val(settings.downPayment);
        $('#txtPropertyTaxes').val(settings.propertyTaxes);
        if (settings.hoaDues == true) {
            $('#txtHOADues').val(settings.hoaDues);
        }
        $('#txtHomeInsurance').val(settings.homeInsurance);

        if (settings.noInterestSelect == false) {
            $('#txtInterestRate').hide();
            $('#dropInterestRate').show();

            $('#dropInterestRate').empty();
            for (var i = 0; i < settings.interestRate.length; i++) {
                if (i == 0) {
                    $('#dropInterestRate').append('<option value="' + settings.interestRate[i] + '" selected="selected">' + settings.interestRate[i] + '</option>');
                } else {
                    $('#dropInterestRate').append('<option value="' + settings.interestRate[i] + '">' + settings.interestRate[i] + '</option>');
                }
            }


        } else {
            $('#txtInterestRate').show();
            $('#dropInterestRate').hide();
        }
        if (settings.noLoanTermSelect == false) {
            $('#txtLoanTerms').hide();
            $('#dropLoanTerms').show();

            $('#dropLoanTerms').empty();
            for (var i = 0; i < settings.loanTerms.length; i++) {
                if (i == 0) {
                    $('#dropLoanTerms').append('<option value="' + settings.loanTerms[i] + '" selected="selected">' + settings.loanTerms[i] + '</option>');
                } else {
                    $('#dropLoanTerms').append('<option value="' + settings.loanTerms[i] + '">' + settings.loanTerms[i] + '</option>');
                }
            }
            if (settings.loanTermDefault != 0) {
                $('#dropLoanTerms').val(settings.loanTermDefault);
            }
        } else {
            $('#txtLoanTerms').show();
            $('#dropLoanTerms').hide();
        }


        $('#txtInterestRate').val($('#dropInterestRate').val());
        $('#txtLoanTerms').val($('#dropLoanTerms').val());

        // hideOptions();
        // $('#divMortgage').show();
        // $('#optMortgage')[0].checked = true;
        //  $('#optMortgage').trigger('click');
        //  $('#optMortgage').trigger('change');
        $('#principal').tab('show');

        $('#advanced').hide();
        $('#amort').hide();

        $(document).on('click', "#myTab a", function (e) {
            e.preventDefault()

            $(this).tab('show')
            var href = $(this).attr('href');

            $('#advanced').hide();
            $('#principal').hide();
            $('#amort').hide();


            switch (href) {
                case "#principal":
                    $('#principal').show();
                    break;
                case "#charts":
                    $('#charts').show();
                    try {
                        plot1.replot();
                        plot2.replot();
                    } catch (err) {
                    }
                    break;
                case "#amort":
                    $('#amort').show();

                    break;
                default:
                    $('#principal').show();
                    break;
            }
        });



        $("input[data-btnclear='true']").each(function () {
            if (($(this)[0].id == "txtLoanTerms" && settings.noLoanTermSelect == false) || ($(this)[0].id == "txtInterestRate" && settings.noInterestSelect == false)) {

            } else {
                if ($(this).val() != '') {
                    $('<div class="input-group-append clear-value"><span class="input-group-text">X</span></div>').insertAfter($(this));
                    var textbox = $(this);
                    $(this).next(".clear-value").on("click", function () {
                        textbox.val('');
                        $(this).off("click");
                        $(this).remove();
                    });
                }
            }
        });




        function addClearButton(item) {


            if ($(item).val() != '') {


                if ($(item).next('.clear-value').text() != 'X') {

                    $('<div class="input-group-append clear-value"><span class="input-group-text">X</span></div>').insertAfter($(item));
                    var textbox = $(item);

                    $(item).next(".clear-value").on("click", function () {
                        textbox.val('');
                        $(this).off("click");
                        $(this).remove();
                    });
                }
            } else {
                if (!$(item).next('.clear-value')) {
                    $(item).next(".clear-value").off("click");
                    $(item).next(".clear-value").remove();
                }
            }
        }


        callFcbtMortgagePayment();

        return this;


    }

    function setAndroidCurrencyFormat(ctrl) {
        var str = $(ctrl).fcbtNumberOnly({ returnvalue: true });
        str = str.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1,').split('').reverse().join('').replace(/^[\,]/, '');
        $(ctrl).val(str);
    }

    function callFcbtMortgagePayment() {

        var html = '';
        if ($('#txtPurchasePrice').val() == 0) {
            html += 'Purchase price<br />';
        }
        if ($('#txtLoanTerms').val() == 0) {
            html += 'Loan term<br />';
        }
        if ($('#txtInterestRate').val() == 0) {
            html += 'Interest rate<br />';
        }
        if (html != '') {

            clearTimeout(timeoutId);
            var beginHtml = '<div class="row mt-40"><div class="col-md-12 reqcal">';

            beginHtml += '<p><small>Complete required items to view chart</small></p>'

            html = beginHtml + '</div></div>';

            $('#chart1').html('');
            $('#chart2').html('');
            $('#chart1').hide();
            $('#chart2').hide();
            $('#nochart').html(html);
            $('#nochart').show();

            $('#divmontlypayment').html('');
            $('#divmontlypayment2').html('');

        } else {

            $('#chart1').show();
            $('#chart2').show();

            $('#nochart').hide();
            $('#nochart').html('');


            clearTimeout(timeoutId);
            timeoutId = setTimeout(fcbtMortgagePayment, secs);
        }

    }
    // function hideOptions() {
    //    $('#divMortgage').hide();
    //   $('#divAmortization').hide();
    // }
    /*jQuery Extension - helper section */
    $.fn.fcbtNumberOnly = function (options) {

        var settings = $.extend({
            returnvalue: false
        }, options);

        var textval = this.val();

        if (this.val() == '' || this.val() == undefined)
            return 0;

        var hasBadValue = false;
        var goodValues = "";
        for (var i = 0; i < textval.length; i++) //loop through each character
        {
            var num = textval.substring(i, i + 1);
            if (isNaN(num)) {
                //not a number don't us
                hasBadValue = true;
            } else {
                goodValues = goodValues.toString() + num.toString();
                //place in goodvalues string
            }
        }
        if (settings.returnvalue == false) {
            var currentpos = doGetCaretPosition(this);
            //if the goodValues from a 
            if ((this.val().length > goodValues.length) && (hasBadValue == true)) {
                currentpos--;
            }
            this.val(goodValues);

            setCaretPosition($(this)[0], currentpos);
        } else {
            return goodValues;
        }
    }
    $.fn.fcbtCurrencyFormat = function () {

        if (isAndroid == false) {
            $.when(setCurrencyFormat($(this))).then(
                function (status) {
                    var sp = status.split("||");
                    setCaretPosition($(sp[1])[0], sp[0]);
                },
                function (status) {
                    //alert("error");
                },
                function (status) {
                    //progress info
                }
            );
        } else {
            setCurrencyFormat($(this));
        }

    }
    function setCurrencyFormat(ctrl) {

        if (isAndroid == false) {

            var d = new $.Deferred();
            var currentpos = doGetCaretPosition(ctrl);

            var commasbefore = countnumof(ctrl.val().substring(0, currentpos), ",");
            var badChars = countBadChar(ctrl.val())
            ctrl.fcbtNumberOnly();
            var str = ctrl.val();

            str = str.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1,').split('').reverse().join('').replace(/^[\,]/, '');


            var commasafter = countnumof(str.substring(0, currentpos), ",");
            currentpos = currentpos - badChars;
            currentpos = currentpos + (commasafter - commasbefore);
            ctrl.val(str);
            var val = currentpos.toString() + "||#" + $(ctrl)[0].id;

            d.resolve(val);

            return d.promise();
        } else {

            ctrl.fcbtNumberOnly();


        }
    }
    $.fn.fcbtPercentOnly = function (options) {



        var settings = $.extend({
            numberOfDecimals: 2,
            returnvalue: false
        }, options);

        var textval = this.val(); //value in text box



        if (this.val() == '' || this.val() == undefined)
            return 0;


        var hasBadValue = false;
        var goodValues = "";
        var boolReached = false;
        var dpoints = 0;

        var numDec = 0;

        for (var i = 0; i < textval.length; i++) //loop through each character
        {
            var num = textval.substring(i, i + 1);
            if (isNaN(num)) {

                //not a number don't use
                //if decimal ensure it is the only one          
                if (num == "." && numDec == 0) {
                    goodValues = goodValues.toString() + num.toString();
                    numDec = 1;
                } else {
                    hasBadValue = true;
                }
            } else {

                if (numDec == 1) {
                    if (dpoints == settings.numberOfDecimals) {
                        boolReached = true;
                    }
                    dpoints++;
                }
                if (!boolReached) {
                    goodValues = goodValues.toString() + num.toString();
                }
                //place in goodvalues string
            }
        }

        if (goodValues > 100) {
            goodValues = 100;
        }

        if (settings.returnvalue == false) {
            var currentpos = doGetCaretPosition(this);
            if ((this.val().length > goodValues.length) && (hasBadValue == true)) {
                currentpos--;
            }
            this.val(goodValues);
            setCaretPosition($(this)[0], currentpos);

        } else {
            return goodValues;
        }


    }
    function fcbtMortgagePayment() {

        var blnPassed = true;

        /*Calculate monthly mortgage payment simple*/
        var houseValue = 0;
        houseValue = $('#txtPurchasePrice').fcbtNumberOnly({ returnvalue: true });
        var downPayment = 0;

        if (moneydown == true) {
            downPayment = $('#txtDown').fcbtNumberOnly({ returnvalue: true });
        } else {
            downPayment = houseValue / 100 * $('#txtDown').fcbtPercentOnly({ returnvalue: true });
        }


        var term = $('#txtLoanTerms').val();
        var interestRate = $('#txtInterestRate').val();

        var ppval = houseValue - downPayment;

        //calculate payment when it is quarterly or semi annually too.
        var paymentsPerYear = 12;
        if ($('#dropPaymentFrequency').length != -1) {
            paymentsPerYear = $('#dropPaymentFrequency').val();
        }

        var monthlyPayment = calculate_payment(ppval, (interestRate / 100) / paymentsPerYear, term * paymentsPerYear);

        var pTax = $('#txtPropertyTaxes').fcbtPercentOnly({ returnvalue: true });
        var hoaDues = 0;
        if ($('#txtHOADues').length != 0) {
            hoaDues = $('#txtHOADues').fcbtNumberOnly({ returnvalue: true });
        }
        var homeIns = $('#txtHomeInsurance').fcbtNumberOnly({ returnvalue: true });
        pTax = roundNumber(((houseValue / 100) * pTax) / 12, 2);

        homeIns = homeIns / 12;
        homeIns = roundNumber(homeIns, 2)
        var total = parseInt(pTax) + parseInt(homeIns) + parseInt(hoaDues);

        total = roundNumber(parseInt(monthlyPayment) + parseInt(total), 2);

        if ($('#txtHOADues').length != 0) {

            var data = [['&nbsp;Mortgage - $' + formatCurrency(monthlyPayment) + '&nbsp;', roundNumber(monthlyPayment, 2)], ['&nbsp;Taxes - $' + formatCurrency(pTax) + '&nbsp;', roundNumber(pTax, 2)], ['&nbsp;Insurance - $' + formatCurrency(homeIns) + '&nbsp;', homeIns], ['&nbsp;HOA - $' + formatCurrency(hoaDues) + '&nbsp;', roundNumber(hoaDues, 2)]];

        } else {
            var data = [['&nbsp;Mortgage - $' + formatCurrency(monthlyPayment) + '&nbsp;', roundNumber(monthlyPayment, 2)], ['&nbsp;Taxes - $' + formatCurrency(pTax) + '&nbsp;', roundNumber(pTax, 2)], ['&nbsp;Insurance - $' + formatCurrency(homeIns) + '&nbsp;', homeIns]];

        }

        var paymentType = "Monthly";
        if ($('#dropPaymentFrequency').length != 0) {

            paymentType = $('#dropPaymentFrequency option:selected').text();
        }

        $('#divmontlypayment').html(paymentType + '&nbsp;Payment $' + formatCurrency(monthlyPayment) + '<p class="explain"><span class="xtiny">Does not include taxes and insurance</span></p>');
        $('#divmontlypayment2').html(paymentType + '&nbsp;Payment $' + formatCurrency(monthlyPayment) + '<p class="explain"><span class="xtiny">Does not include taxes and insurance</span></p>');

        updatecharts(data);

    }
    /*helper methods section */
    function switchValues(purchaseprice, amountdown, format) {
        var strValue = '';
        if (purchaseprice != '' || purchaseprice != 0 || amountdown != '' || amountdown != 0) {
            if (format == "%") {
                var v = parseFloat(amountdown / purchaseprice * 100)
                truepercent = v;
                strValue = v.toFixed(2);
                trueValue = strValue;
            } else {

                if (amountdown == trueValue) {
                    strValue = (parseFloat(purchaseprice / 100) * truepercent) / 100;
                } else {
                    strValue = (parseFloat(purchaseprice / 100) * amountdown) / 100;
                    truepercent = 0;
                    trueValue = 0;
                }

                strValue = strValue.toFixed(2);
            }
        }
        return strValue;
    }
    function roundNumber(original_number, decimals) {
        var result1 = original_number * Math.pow(10, decimals)
        var result2 = Math.round(result1)
        var result3 = result2 / Math.pow(10, decimals)
        return result3;
    }
    function calculate_payment(PV, IR, NP) {
        var PMT = (PV * IR) / (1 - Math.pow(1 + IR, (-1 * NP)))
        return roundNumber(PMT, 2)
    }
    function formatCurrency(str) {

        return str.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1,').split('').reverse().join('').replace(/^[\,]/, '');
    }
    function updatecharts(data) {


        var mortgage = 1200;
        var propertytaxes = 400;
        var homeinsurance = 100;
        var hoadues = 33;

        $('#chart1').html('');
        $('#chart2').html('');
        //getvalues
        if (data == '') {

            if (settings.hoaDuesOn == true) {
                data = [['&nbsp;Mortgage - $1200&nbsp;', mortgage], ['&nbsp;Taxes - $400&nbsp;', propertytaxes], ['&nbsp;Insurance - $100&nbsp;', homeinsurance], ['&nbsp;HOA - $33&nbsp;', hoadues]];
            } else {
                data = [['&nbsp;Mortgage - $1200&nbsp;', mortgage], ['&nbsp;Taxes - $400&nbsp;', propertytaxes], ['&nbsp;Insurance - $100&nbsp;', homeinsurance]];

            }


        }


        plot1 = $.jqplot('chart1', [data],
            {
                height: 285,
                width: 285,
                grid: {
                    drawGridLines: false,        // wether to draw lines across the grid or not.
                    gridLineColor: '#cccccc',   // *Color of the grid lines.
                    background: '#fff',      // CSS color spec for background color of grid.
                    borderColor: '#fff',     // CSS color spec for border around grid.
                    borderWidth: 0.0,           // pixel width of border around grid.
                    shadow: false,               // draw a shadow for grid.
                    shadowAngle: 0,            // angle of the shadow.  Clockwise from x axis.
                    shadowOffset: 0,          // offset from the line of the shadow.
                    shadowWidth: 0,             // width of the stroke for the shadow.
                    shadowDepth: 0,             // Number of strokes to make when drawing shadow.
                    // Each stroke offset by shadowOffset from the last.
                    shadowAlpha: 0,
                },
                seriesDefaults: {
                    // Make this a pie chart.
                    renderer: $.jqplot.PieRenderer,
                    trendline: { show: false },
                    rendererOptions: {
                        padding: 15,
                        showDataLabels: false,
                        shadowAlpha: 0,
                        shadowDepth: 0,
                        shadowOffset: 0
                    },
                    seriesColors: ['#9BBB59', '#8064A2', '#4F81BD', '#C0504D']
                },
                legend: {
                    show: true,
                    placement: 'outside',
                    disableIEFading: true,
                    rendererOptions: {
                        numberRows: 2,
                        border: 'none'
                    },
                    location: 's',
                    marginTop: '10px',
                    marginLeft: '2px',
                    marginRight: '0px',
                    marginBottom: '200px',
                    background: 'white'
                }
            })

        plotS1.length = 0;

        buildAmortTable();

        plotS1[plotS1.length - 1][1] = 0;

        plot2 = jQuery.jqplot('chart2', [plotS1],
            {
                width: 265,
                animate: true,
                // Will animate plot on calls to plot1.replot({resetAxes:true})
                animateReplot: true,
                grid: {
                    drawGridLines: true,        // wether to draw lines across the grid or not.
                    gridLineColor: '#cccccc',   // *Color of the grid lines.
                    background: '#fff',      // CSS color spec for background color of grid.
                    borderColor: '#fff',     // CSS color spec for border around grid.
                    borderWidth: 0.0,           // pixel width of border around grid.
                    shadow: false,               // draw a shadow for grid.
                    shadowAngle: 0,            // angle of the shadow.  Clockwise from x axis.
                    shadowOffset: 0,          // offset from the line of the shadow.
                    shadowWidth: 0,             // width of the stroke for the shadow.
                    shadowDepth: 0,             // Number of strokes to make when drawing shadow.
                    // Each stroke offset by shadowOffset from the last.
                    shadowAlpha: 0,
                },
                series: [
                    {
                        showMarker: true,
                        pointLabels: {
                            show: false,
                        },
                        renderer: $.jqplot.LineRenderer,
                        showHighlight: true,
                        yaxis: 'y2axis',
                        highlighter: {
                            show: true
                        },
                        rendererOptions: {
                            // Speed up the animation a little bit.
                            // This is a number of milliseconds.  
                            // Default for bar series is 3000.  
                            animation: {
                                speed: 1500
                            },
                            barWidth: 15,
                            barPadding: -15,
                            barMargin: 0,
                            highlightMouseOver: true
                        }
                    }
                ],
                axesDefaults: {
                    pad: 0
                },
                axes: {
                    // These options will set up the x axis like a category axis.
                    xaxis: {
                        label: 'Year',
                        tickInterval: 1,
                        drawMajorGridlines: true,
                        drawMinorGridlines: false,
                        drawMajorTickMarks: true,
                    },
                    y2axis: {
                        tickOptions: {
                            formatString: "$%'d"
                        },
                        rendererOptions: {
                            // align the ticks on the y2 axis with the y axis.
                            alignTicks: true,
                            forceTickAt0: true

                        }
                    }
                },
                highlighter: {
                    show: true,
                    showMarker: true,
                    showLabel: true,
                    useAxesFormatters: true,
                    tooltipAxes: 'both',
                    bringSeriesToFront: true,
                    sizeAdjust: 7.5, tooltipLocation: 'ne'
                }
            });
    }

    // function tooltipContentEditor(str, seriesIndex, pointIndex, plot) {
    // display series_label, x-axis_tick, y-axis value
    // tooltipContentEditor: tooltipContentEditor
    //   return plot.series[seriesIndex]["label"] + ", " + plot.data[seriesIndex][pointIndex];
    // }

    function buildAmortTable() {



        var html = '';

        if ($('#txtPurchasePrice').val() == 0) {
            html += '<p>Purchase price is required</p>';
        }

        if ($('#txtLoanTerms').val() == 0) {
            html += '<p>Loan term is required</p>';
        }

        if ($('#txtInterestRate').val() == 0) {
            html += '<div class="row mt-40"><div class="col-md-12 reqcal"><p><small>Interest rate is required</small></p></div></div>';
        }

        if (html == '') {

            //html += '<span class="xtiny visible-xs bottommarginminus10">To see principal and interest columns place device in landscape mode.</span>';
            html += '<div class="fixed-table-container">'; //formerly flush with top
            html += '<div class="header-background"> </div>';
            html += '<div class="fixed-table-container-inner">';
            html += '<table cellspacing="0">';
            html += '<thead>';
            html += '<tr>';

            var paymentType = "Month";
            if ($('#dropPaymentFrequency').length != 0) {

                if ($('#dropPaymentFrequency').val() == 12) {
                    paymentType = "Month";
                }
                if ($('#dropPaymentFrequency').val() == 2) {
                    paymentType = "Semiannual";
                }
                if ($('#dropPaymentFrequency').val() == 4) {
                    paymentType = "Quarter";
                }
            }

            html += '<th class="first"><div class="th-inner">' + paymentType + '</div></th>';


            html += '<th class="second"><div class="th-inner">P & I</div></th>';
            html += '<th class="third hidden-xs"><div class="th-inner">Principal</div></th>';
            html += '<th class="fourth hidden-xs"><div class="th-inner">Interest</div></th>';
            html += '<th class="fifth"><div class="th-inner">Balance</div></th>';
            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';

            var rowt = '<tr class="amortrow" ><td class="col1">{0}</td><td class="col2">${1}</td><td class="col3 hidden-xs">${2}</td><td  class="col4 hidden-xs">${3}</td><td  class="col5">${4}</td></tr>';
            var altrowt = '<tr class="amortrowalt"><td class="col1">{0}</td><td class="col2">${1}</td><td class="col3 hidden-xs">${2}</td><td  class="col4 hidden-xs">${3}</td><td  class="col5">${4}</td></tr>';

            var months = 1;
            var years = 1;


            var ip = 0;


            var monthlyinterest = 0;
            var monthlyprincipal = 0;

            var houseValue = 0;
            houseValue = $('#txtPurchasePrice').fcbtNumberOnly({ returnvalue: true });
            var downPayment = 0;
            if (moneydown == true) {
                downPayment = $('#txtDown').fcbtNumberOnly({ returnvalue: true });
            } else {
                downPayment = houseValue / 100 * $('#txtDown').fcbtPercentOnly({ returnvalue: true });
            }

            var term = $('#txtLoanTerms').val();
            var interestRate = $('#txtInterestRate').val();

            var ppval = houseValue - downPayment;


            var paymentsPerYear = 12;
            if ($('#dropPaymentFrequency').length != -1) {
                paymentsPerYear = $('#dropPaymentFrequency').val();
            }



            var monthlyPayment = calculate_payment(ppval, (interestRate / 100) / paymentsPerYear, term * paymentsPerYear);
            var pr = ppval;

            plotS1.length = 0;

            var arr = [];
            arr.push(0);
            arr.push(ppval);
            plotS1.push(arr);

            for (var j = 0; j < (term * paymentsPerYear); j++) {

                var iseven = 0;
                iseven = j % 2;


                monthlyinterest = roundNumber(pr * ((interestRate / 100) / paymentsPerYear), 2);

                monthlyprincipal = roundNumber(monthlyPayment - monthlyinterest, 2);

                ip = roundNumber(ip + monthlyinterest, 2);
                pr = roundNumber(pr - monthlyprincipal, 2);

                var diff = 0;

                if (j === (term * paymentsPerYear) - 1) {
                    if (pr < 0) {
                        diff = Math.abs(pr);
                    } else {
                        diff = pr * -1;
                    }

                }
                var mp = roundNumber(monthlyprincipal + diff, 2);



                if (iseven) {
                    var secondrow = "";


                    var monPay = +monthlyPayment + +diff;

                    secondrow = rowt.replace("{0}", months);
                    secondrow = secondrow.replace("{1}", formatCurrency(roundNumber(monPay, 2), true));
                    secondrow = secondrow.replace("{2}", formatCurrency(mp, true));
                    secondrow = secondrow.replace("{3}", formatCurrency(monthlyinterest, true));
                    secondrow = secondrow.replace("{4}", formatCurrency(roundNumber(+pr + +diff, 2), true));




                    html += secondrow;
                }
                else {
                    var firstrow = "";




                    firstrow = altrowt.replace("{0}", months);
                    firstrow = firstrow.replace("{1}", formatCurrency(roundNumber(+monthlyPayment + +diff, 2), true));
                    firstrow = firstrow.replace("{2}", formatCurrency(mp, true));
                    firstrow = firstrow.replace("{3}", formatCurrency(monthlyinterest, true));
                    firstrow = firstrow.replace("{4}", formatCurrency(roundNumber(+pr + +diff, 2), true));

                    html += firstrow;
                }

                if (months == paymentsPerYear) {

                    if (j === (term * paymentsPerYear) - 1) {
                        pr = 0;
                    }

                    html += '<tr class="amortrowdivider"><td>';
                    html += 'Year&nbsp;' + years + '&nbsp;&nbsp;</td><td colspan="4" style="text-align: right;">Balance&nbsp;&nbsp;$' + formatCurrency(pr, true) + '&nbsp;&nbsp;&nbsp;&nbsp;';
                    html += '</td></tr>';


                    var arr = [];
                    arr.push(years);
                    arr.push(pr);
                    plotS1.push(arr);


                    years++;

                    months = 1;
                } else {
                    months++;
                }
            }
            html += '</tbody>';
            html += '</table>';
            html += '</div>';
            html += '</div>';

            var header = "Mortage  $" + formatCurrency(ppval, true) + " & Interest  $" + formatCurrency(roundNumber(ip, 0));

            $('#mortamount').html(header);
        } else {

            $('#mortamount').html('');
            $('#divmontlypayment').html('');
            $('#divmontlypayment2').html('');
        }


        $("#divamortholder").html(html);


    }

    function goodkey(key) {
        if (key == 37) return false;
        if (key == 38) return false;
        if (key == 39) return false;
        if (key == 40) return false;

        return true;
    }
    function doGetCaretPosition(ctrl) {

        var CaretPos = 0; // IE Support
        try {
            if (document.selection) {
                $(ctrl).focus();
                var Sel = document.selection.createRange();
                Sel.moveStart('character', -$(ctrl).val().length);
                CaretPos = Sel.text.length;
            }
            else if ($(ctrl)[0].selectionStart || $(ctrl)[0].selectionStart == '0') {

                CaretPos = $(ctrl)[0].selectionStart;
            }
        } catch (err) {

        }
        // alert(CaretPos);
        return (CaretPos);
    }
    function setCaretPosition(ctrl, pos) {
        try {
            if (ctrl.setSelectionRange) {
                ctrl.focus();
                ctrl.setSelectionRange(pos, pos);
            }
            else if (ctrl.createTextRange) {
                var range = ctrl.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        } catch (err) {

        }
    }
    function countnumof(haystack, needle) {
        var count = 0;
        for (var i = 0; i < haystack.length; i++) {
            if (haystack.substring(i, i + 1) == needle) {
                count++;
            }
        }
        return count;
    }
    function countBadChar(haystack) {
        var count = 0;
        for (var i = 0; i < haystack.length; i++) {
            if (isNaN(haystack[i]) && haystack[i] != ",") {
                count++;
            }
        }
        return count;
    }

}